import React from 'react';
import cx from 'classnames';
import { featureFlagClient } from '@trello/feature-flag-client';
import styles from './CardLabel.less';

export type LabelColor =
  | 'black'
  | 'blue'
  | 'green'
  | 'lime'
  | 'orange'
  | 'pink'
  | 'purple'
  | 'red'
  | 'sky'
  | 'yellow'
  | 'gray'
  | 'none';

type LabelPattern =
  | 'striped'
  | 'transparent'
  | 'slant-right'
  | 'slant-left'
  | 'checkered'
  | 'StripeDiagonal'
  | 'WaveSquare'
  | 'StripeVertical'
  | 'DotsChecker'
  | 'GrooveDiagonal'
  | 'StripeHorizontal'
  | 'BrickDiagonal'
  | 'Scale'
  | 'BrickHorizontal'
  | 'BrickVertical'
  | 'none';

interface CardLabelProps {
  className?: string;
  color?: LabelColor | null;
  pattern?: LabelPattern | null;
}

function showNewLabelPatterns() {
  return featureFlagClient.get('remarkable.new-color-blind-patterns', false);
}

export const labelColorToColorBlindPattern: {
  [key in LabelColor]:
    | 'striped'
    | 'transparent'
    | 'slant-right'
    | 'slant-left'
    | 'checkered'
    | 'StripeDiagonal'
    | 'WaveSquare'
    | 'StripeVertical'
    | 'DotsChecker'
    | 'GrooveDiagonal'
    | 'StripeHorizontal'
    | 'BrickDiagonal'
    | 'Scale'
    | 'BrickHorizontal'
    | 'BrickVertical'
    | 'none';
} = {
  black: showNewLabelPatterns() ? 'BrickVertical' : 'striped',
  blue: showNewLabelPatterns() ? 'StripeHorizontal' : 'transparent',
  green: showNewLabelPatterns() ? 'StripeDiagonal' : 'slant-right',
  lime: showNewLabelPatterns() ? 'Scale' : 'slant-left',
  orange: showNewLabelPatterns() ? 'StripeVertical' : 'striped',
  pink: showNewLabelPatterns() ? 'BrickHorizontal' : 'slant-right',
  purple: showNewLabelPatterns() ? 'GrooveDiagonal' : 'slant-left',
  red: showNewLabelPatterns() ? 'DotsChecker' : 'checkered',
  sky: showNewLabelPatterns() ? 'BrickDiagonal' : 'transparent',
  yellow: showNewLabelPatterns() ? 'WaveSquare' : 'checkered',
  gray: 'none',
  none: 'none',
};

export const CardLabel: React.FC<CardLabelProps> = ({
  className,
  color,
  pattern,
  children,
}) => {
  const labelClasses = cx(
    className,
    styles.label,
    children && styles.expanded,
    color === 'blue' && styles.blue,
    color === 'green' && styles.green,
    color === 'lime' && styles.lime,
    color === 'sky' && styles.sky,
    color === 'orange' && styles.orange,
    color === 'pink' && styles.pink,
    color === 'purple' && styles.purple,
    color === 'red' && styles.red,
    color === 'yellow' && styles.yellow,
    color === 'black' && styles.black,
    color === 'gray' && styles.gray,
    pattern === 'striped' && styles.striped,
    pattern === 'slant-left' && styles.slantLeft,
    pattern === 'slant-right' && styles.slantRight,
    pattern === 'checkered' && styles.checkered,

    pattern === 'StripeDiagonal' && styles.StripeDiagonal,
    pattern === 'WaveSquare' && styles.WaveSquare,
    pattern === 'StripeVertical' && styles.StripeVertical,
    pattern === 'DotsChecker' && styles.DotsChecker,
    pattern === 'GrooveDiagonal' && styles.GrooveDiagonal,
    pattern === 'StripeHorizontal' && styles.StripeHorizontal,
    pattern === 'BrickDiagonal' && styles.BrickDiagonal,
    pattern === 'Scale' && styles.Scale,
    pattern === 'BrickHorizontal' && styles.BrickHorizontal,
    pattern === 'BrickVertical' && styles.BrickVertical,
  );
  return <span className={labelClasses}>{children}</span>;
};
